const matchRefs = {
  setupPlaceholder: (container: Document): void => void container,
  InContentBanner: ({
    center = false,
  }: {
    center?: boolean;
  }): React.ReactNode => void center,
  columnsContainerClassName: (): string => "",
};
export default matchRefs;
